import { getArrayLength } from 'utils';
import {
  CHART_MARGIN,
  MIN_NUMBER_OF_TICKS,
  NUMBER_OF_Y_TICKS,
  X_TICK_MIN_WIDTH,
} from './data';

export const getNumberOfTicksForWidth = (
  width: number,
  minTickWidth: number,
) => {
  const availableWidth = Math.max(
    width - CHART_MARGIN.left - CHART_MARGIN.right,
    0,
  );

  return Math.max(
    MIN_NUMBER_OF_TICKS,
    Math.floor(availableWidth / minTickWidth),
  );
};

export const getEvenlySpacedValues = (values: string[], maxValues: number) => {
  const valuesLength = getArrayLength(values);

  if (valuesLength <= maxValues) return values;

  const step = Math.ceil((valuesLength - 1) / (maxValues - 1));

  return values.filter(
    (_, index) => index % step === 0 || index === valuesLength - 1,
  );
};

export const getXTickValues = (
  values: string[],
  chartWidth = 0,
  xTickMinWidth = X_TICK_MIN_WIDTH,
) => {
  const numberOfTicks = getNumberOfTicksForWidth(chartWidth, xTickMinWidth);

  return getEvenlySpacedValues(values, numberOfTicks);
};

export const getYTickValues = (
  maxValue: number,
  maxNumberOfTicks = NUMBER_OF_Y_TICKS,
) => {
  if (!maxValue)
    return Array.from({ length: maxNumberOfTicks }, (_, index) => index);

  const numberOfTicks = Math.min(maxNumberOfTicks, Math.ceil(maxValue) + 1);
  const increment = Math.ceil(maxValue / (numberOfTicks - 1)) || 1;

  return Array.from({ length: numberOfTicks }, (_, index) => index * increment);
};
